import { Button } from '@bfe/moly';
import { Page } from '@/config/track-config';
import { useFm } from '@web3/base-hooks';
import { useConnectWalletModal } from '@web3fe/infra';
import { LotteryFlag, LotteryType } from '@/services/lottery';
import { useRedemptionWallet } from '@/hooks/wallet';
import {
  userLotteryStore,
  useUserLotteryStore,
} from '@/store/userLotteryStatusStore';
import { useEffect, useState } from 'react';
import { LuckyDraw } from '../LuckyDraw';
import { LotteryButtonGroup } from './LotteryButtonGroup';
import { isNull } from 'lodash-es';

export const ActionButtons = () => {
  const { isPrivateKeyWallet, isBybitWallet, isConnectedWallet } =
    useRedemptionWallet();
  const fm = useFm();

  if (!isConnectedWallet || !isBybitWallet) {
    return null;
  }

  if (isPrivateKeyWallet) {
    return (
      <Button className="btn-brand" disabled>
        {fm('noTicket')}
      </Button>
    );
  }

  return <LotteryButtons />;
};

const ConnectWalletButton = () => {
  const connectWallet = useConnectWalletModal();
  const fm = useFm();

  return (
    <Button
      className="btn-brand"
      data-spm-even="Web3UserClick"
      data-spm-data={JSON.stringify({
        page_name: Page.RewardsPage,
        button_name: 'Web3Points_ConnectWallet',
      })}
      onClick={() => connectWallet.show()}
    >
      {fm('createWallet')}
    </Button>
  );
};

const LotteryButtons = () => {
  const {
    wallet: { walletId, walletType },
  } = useRedemptionWallet();
  const { data, isLoading, error } = useUserLotteryStore();
  const [showLotteryModal, setShowLotteryModal] = useState(false);
  const [currentLotteryType, setCurrentLotteryType] =
    useState<LotteryType | null>(null);

  useEffect(() => {
    if (walletId && walletType) {
      userLotteryStore.getState().getUserRewardStatus({
        walletId,
        walletType,
      });
    }
  }, [walletId, walletType]);

  if (isLoading || error) {
    return null;
  }

  const handleLotteryStart = (type: LotteryType) => {
    setCurrentLotteryType(type);
    setShowLotteryModal(true);
  };

  const handleCloseLotteryModal = () => {
    setShowLotteryModal(false);
    setCurrentLotteryType(null);
    userLotteryStore.getState().getUserRewardStatus(
      {
        walletId,
        walletType,
      },
      true
    );
  };

  return (
    <>
      <LotteryButtonGroup
        remainingTickets={data?.remainingLotteryTimes ?? 0}
        lotteryStatus={data?.lotteryFlag ?? LotteryFlag.NotEnoughStock}
        onLotteryStart={handleLotteryStart}
      />

      {showLotteryModal && !isNull(currentLotteryType) && (
        <LuckyDraw
          lotteryType={currentLotteryType}
          onClose={handleCloseLotteryModal}
        />
      )}
    </>
  );
};
